export default {
  "content": "<rect y=\".5\" width=\"40\" height=\"40\" rx=\"20\" fill=\"#EFFAFD\"/><g clip-path=\"url(#clip0_15_2755)\"><path d=\"M24.966 12.5H15a1.033 1.033 0 00-1.038 1.034v13.932A1.034 1.034 0 0015 28.5h9.97A1.034 1.034 0 0026 27.466V13.534a1.034 1.034 0 00-1.034-1.034zM24 25.132a.368.368 0 01-.368.368h-7.264a.368.368 0 01-.368-.368V14.868a.368.368 0 01.368-.368H17v.279a.721.721 0 00.72.721h4.559a.721.721 0 00.72-.721V14.5h.633a.368.368 0 01.368.368v10.264z\" fill=\"#028EB7\"/></g><defs><clipPath id=\"clip0_15_2755\"><path fill=\"#fff\" transform=\"translate(12 12.5)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "40",
    "height": "41",
    "viewBox": "0 0 40 41",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};